module.exports = __webpack_public_path__ + "static/media/IVbh.2a6ca26d.png";